import { Service } from '@packlink/packlink-sdk';
import { IServiceState } from '@types';

const InPost = 'INPOST';

export const isInPostService = (service: IServiceState | Pick<Service, 'carrierProductId'> | null): boolean =>
    !!(service && service.carrierProductId && service.carrierProductId.includes(InPost));
